export const range = (n: number) => {
  return Array.from({ length: n }, (_, i) => i);
};
